import React from 'react';
import { colors } from '@modernhealth/vital-foundation';
import { Link } from 'react-router-dom';

/**
 * This link expands to become the entire click target
 * for a card. Do _not_ use this more than once per card.
 */
export const CircleCardHeaderLink: React.FC<{
    name: string;
    'aria-describedby': string | null;
    to: string;
}> = ({ to, name, 'aria-describedby': describedby }) => (
    <Link
        css={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            WebkitLineBreak: 'auto',
            overflow: 'hidden',
            fontSize: 'inherit',
            fontWeight: 400,
            color: colors.gray85,
            '&:hover': {
                color: colors.gray85,
            },
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
            },
        }}
        to={to}
        aria-describedby={describedby ?? undefined}
    >
        {name}
    </Link>
);
